// extracted by mini-css-extract-plugin
export default {"flex-container":"size_flex-container__wLXIu","flex-child":"size_flex-child__sNuWG","plusMinus":"size_plusMinus__6fBWW","button":"size_button__6deN9"};